import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { NgMarqueeModule } from 'ng-marquee';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { Navbar } from './components/layouts/navbar/navbar.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { HomeComponent } from './components/pages/home/home.component';
import { UnderConstructionComponent } from './components/pages/under-construction/under-construction.component';
import { HttpClientModule } from '@angular/common/http';
import { EmitterService } from './EmitterService';
import { PhotoComponent } from './components/pages/photo/photo.component';
import { DetailsComponent } from './details/details.component';
import { NoticeComponent } from './components/pages/notice/notice.component';
import { AppService } from './app.service';
import { TemplatePageComponent } from './template-page/template-page.component';
import { LayoutImageListComponent } from './components/layouts/layout-image-list/layout-image-list.component';
import { LayoutImageSingleComponent } from './components/layouts/layout-image-single/layout-image-single.component';
import { LayoutImageMultipleComponent } from './components/layouts/layout-image-multiple/layout-image-multiple.component';
import { LayoutDocumentListComponent } from './components/layouts/layout-document-list/layout-document-list.component';
import { LayoutDocumentSingleComponent } from './components/layouts/layout-document-single/layout-document-single.component';
import { AsideComponent } from './components/layouts/aside/aside.component';
import { AdministrationComponent } from './components/pages/administration/administration.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { VideoFolderComponent } from './components/pages/video-folder/video-folder.component';
import { VideoGalleryComponent } from './components/pages/video-gallery/video-gallery.component';
import { ImageFolderComponent } from './components/pages/image-folder/image-folder.component';
import { ImageGalleryComponent } from './components/pages/image-gallery/image-gallery.component';
import { TeachersComponent } from './components/pages/teachers/teachers.component';
import { EmployesComponent } from './components/pages/employes/employes.component';
import { PrincipalComponent } from './components/pages/principal/principal.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { ChairmanComponent } from './components/pages/chairman/chairman.component';
import { SchoolTeacherComponent } from './components/pages/school-teacher/school-teacher.component';
import { CollegeTeacherComponent } from './components/pages/college-teacher/college-teacher.component';
import { AchievementComponent } from './components/pages/achievement/achievement.component';
import { NewsComponent } from './components/pages/news/news.component';
import { AcievementTeamComponent } from './components/pages/acievement-team/acievement-team.component';
import { NewIdComponent } from './components/pages/new-id/new-id.component';
import { FallbackImageDirective } from './directives/fallback-image.directive';

@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    FooterComponent,
    HomeComponent,
    Navbar,
    UnderConstructionComponent,
    PhotoComponent,
    DetailsComponent,
    NoticeComponent,
    TemplatePageComponent,
    LayoutImageListComponent,
    LayoutImageSingleComponent,
    LayoutImageMultipleComponent,
    LayoutDocumentListComponent,
    LayoutDocumentSingleComponent,
    AsideComponent,
    AdministrationComponent,
    ContactComponent,

    VideoFolderComponent,
    VideoGalleryComponent,
    ImageFolderComponent,
    ImageGalleryComponent,
    TeachersComponent,
    EmployesComponent,
    PrincipalComponent,
    NotFoundComponent,
    ChairmanComponent,
    SchoolTeacherComponent,
    CollegeTeacherComponent,
    AchievementComponent,
    NewsComponent,
    AcievementTeamComponent,
    NewIdComponent,
    FallbackImageDirective
  ],
  imports: [
    BrowserModule,
    TranslateModule.forRoot(),
    AppRoutingModule,
    NgxScrollTopModule,
    NgMarqueeModule,
    HttpClientModule,

  ],
  providers: [EmitterService, AppService],
  bootstrap: [AppComponent],
})
export class AppModule { }
